import { render, staticRenderFns } from "./statistical-analysis-status-line.vue?vue&type=template&id=8244b482&scoped=true&"
import script from "./statistical-analysis-status-line.ts?vue&type=script&lang=ts&"
export * from "./statistical-analysis-status-line.ts?vue&type=script&lang=ts&"
import style0 from "./statistical-analysis-status-line.scss?vue&type=style&index=0&id=8244b482&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8244b482",
  null
  
)

export default component.exports